import Checkbox from "expo-checkbox";
import { StyleSheet, View } from "react-native";
import CustomText from "./CustomText";

const CheckBoxSelection = ({
  isMultiple = false,
  options = [],
  value = "",
  onChange = () => {},
}) => {
  const selectedValue =
    (value || "")
      .toString()
      ?.split(",")
      .map((iValue) => (iValue || "").toString())
      .filter((_) => _) || [];

  const handleOnValueChange = ({ iValue, isChecked }) => {
    let nValue = iValue;
    if (isMultiple) {
      nValue = selectedValue;
      if (isChecked) {
        nValue = nValue.filter((val) => val != iValue);
      } else {
        nValue.push(iValue);
      }
      nValue = nValue.join(",");
    }

    onChange(nValue);
  };

  return (
    <View style={styles.container}>
      {options.map(({ value: iValue, label }) => {
        const isChecked = selectedValue.includes((iValue || "").toString());
        return (
          <View key={label} style={styles.section}>
            <Checkbox
              style={styles.checkbox}
              value={isChecked}
              onValueChange={() => {
                handleOnValueChange({ iValue, isChecked });
              }}
              color={isChecked ? "#043888" : undefined}
            />
            <CustomText
              style={[styles.text]}
              onPress={() => {
                handleOnValueChange({ iValue, isChecked });
              }}
            >
              {label}
            </CustomText>
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    marginBottom: 20,
  },
  section: { flexDirection: "row", marginVertical: 5, alignItems: "flex-end" },
  checkbox: { marginRight: 15, width: 23, height: 23 },
  text: { fontSize: 16 },
});
export default CheckBoxSelection;
